/**
 * Proportion-bar colors keyed by the 7 UI display categories
 * (ingredient-display-groups.json) — not raw engine type_key.
 */
import config from '../config/ingredient-display-groups.json';

const TYPE_TO_GROUP = (() => {
  const map = Object.create(null);
  for (const group of config.groups) {
    for (const type of group.types) {
      if (map[type]) {
        throw new Error(
          `Ingredient type "${type}" appears in multiple display groups ` +
            `("${map[type]}" and "${group.key}")`
        );
      }
      map[type] = group.key;
    }
  }
  return map;
})();

/** CSS custom-property name for a display-group key. */
export function displayGroupColorVar(groupKey) {
  return `var(--category-${groupKey})`;
}

/**
 * @param {string|undefined|null} type engine type_key (e.g. bud, spice, peel)
 * @returns {string} CSS color value for the matching UI category
 */
export function colorForIngredientType(type) {
  if (type == null || type === '') {
    throw new Error('Ingredient type is required for proportion-bar color');
  }
  const key = String(type).toLowerCase();
  const groupKey = TYPE_TO_GROUP[key];
  if (!groupKey) {
    throw new Error(
      `Ingredient type "${key}" is not in ingredient-display-groups.json; ` +
        'add it to a UI category before coloring the proportion bar'
    );
  }
  return displayGroupColorVar(groupKey);
}
